import { type FC } from "react";
import { userIsLoggedIn } from "~/domains/user/utils/roles";
import PageTitle from "~/common/components/PageTitle/v1/PageTitle";
import useMediaQuery from "~/common/hooks/useMediaQuery";
import { tileBuilder } from "~/features/myAccount/dashboard/components/TileBuilder";
import { getMyCompanyTiles } from "~/features/myAccount/dashboard/sections/myCompanyTiles";
import { userCanSeeMyCompanySettings } from "~/features/myAccount/dashboard/helper/permissions";
import { getMyAccountTiles } from "~/features/myAccount/dashboard/sections/myAccountTiles";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "~/common/utils/screenSizes";
import { useTranslation } from "react-i18next";

export const AccountSettingsPage: FC = () => {
  const loggedIn = userIsLoggedIn();
  const { t } = useTranslation();
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);
  const myCompanyTiles = getMyCompanyTiles();
  const MyAccountTiles = getMyAccountTiles();

  return loggedIn ? (
    <div className={"scha__account-settings " + (isDesktop ? "desktop" : "mobile")}>
      <PageTitle title={t("page.accountSettings.title")} />
      <div className="scha__account-settings__main">
        {MyAccountTiles && MyAccountTiles && MyAccountTiles.length > 0 && (
          <div className="scha__account-settings__section">
            <div className="scha__account-settings__section__my-account">
              <h3 className="scha__account-settings__section__title headline-small mb-3">
                {t("page.accountSettings.section.myAccount.title")}
              </h3>
              <div className="scha__account-settings__section__tiles">{tileBuilder(MyAccountTiles)}</div>
            </div>
          </div>
        )}
        {userCanSeeMyCompanySettings && myCompanyTiles && myCompanyTiles.length > 0 && (
          <div className="scha__account-settings__section">
            <div className="scha__account-settings__section__my-company">
              <h3 className="scha__account-settings__section__title headline-small mt-0 mb-3">
                {t("page.accountSettings.section.myCompany.title")}
              </h3>
              <div className="scha__account-settings__section__tiles">{tileBuilder(myCompanyTiles)}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  ) : (
    <></>
  );
};

export function createAccountSettings() {
  return <AccountSettingsPage />;
}
